import {
	IGetCategoryInfo,
	IGetCategoryInfoV2,
	IGetCategoriesShort,
	IGetCategoriesByCustomerShort,
	IGetCategoriesShortResponse,
	ICreateCategory,
	ICreateCategoryV2,
	IUpdateCategory,
	IUpdateCategoryV2,
	IGetPaginatedCategories,
	ICategory,
	IGetPaginatedCategoriesV2,
	ICategoryV2,
	IGetCategoryPositionList,
	IGetCategoryPositionListV2,
	IGetCategoryPositionChains,
	IUpdateCategoryPositions,
	IGetCategoryRestaurantPropertiesArguments,
	IGetCategoryRestaurantProperties,
	IUpdateCategoryRestaurantProperties,
	IUpdateRestaurantPropertiesAsPatchForCategory,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

// Menu v1
const serviceGetCategoryInfo = (categoryID: string): Promise<IGetCategoryInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Categories/${categoryID}` });
};
// Menu v1
// Menu v2
const serviceGetCategoryInfoV2 = (categoryID: string): Promise<IGetCategoryInfoV2> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/categories/${categoryID}` });
};
// Menu v2

// Menu v1
const serviceGetCategoriesShort = (args: IGetCategoriesShort): Promise<IGetCategoriesShortResponse> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Categories/short`, data: args });
};
// Menu v1
// Menu v2
const serviceGetCategoriesShortV2 = (args: IGetCategoriesShort): Promise<IGetCategoriesShortResponse> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/categories/short`, data: args });
};
// Menu v2

const serviceGetCategoriesByCustomerShort = (
	args: IGetCategoriesByCustomerShort,
): Promise<IGetCategoriesShortResponse> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/customers/${args.customerId}/categories` });
};

// Menu v1
const serviceCreateCategory = (data: ICreateCategory): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Categories`, data });
};
// Menu v1
// Menu v2
const serviceCreateCategoryV2 = (data: ICreateCategoryV2): Promise<AxiosResponse<{ id: string }>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/categories`, data });
};
// Menu v2

// Menu v1
const serviceUpdateCategory = (data: IUpdateCategory): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Categories/${data.id}`, data });
};
// Menu v1
// Menu v2
const serviceUpdateCategoryV2 = (data: IUpdateCategoryV2): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/categories/${data.id}`, data });
};
// Menu v2

// Menu v1
const serviceGetPaginatedCategories = (args: IGetPaginatedCategories): Promise<AxiosResponse<ICategory>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Categories/filtered`, data: args });
};
// Menu v1
// Menu v2
const serviceGetPaginatedCategoriesV2 = (args: IGetPaginatedCategoriesV2): Promise<AxiosResponse<ICategoryV2>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/categories:search`, data: args });
};
// Menu v2

// Menu v1
const serviceDeleteCategory = (categoryID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/Categories/${categoryID}` });
};
// Menu v1
// Menu v2
const serviceDeleteCategoryV2 = (categoryID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/v2/categories/${categoryID}`,
	});
};
// Menu v2

// Menu v1
const serviceGetCategoryPositionList = (restaurantId: string): Promise<IGetCategoryPositionList> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Categories/positionList?restaurantId=${restaurantId}` });
};
// Menu v1
// Menu v2
const serviceGetCategoryPositionListV2 = (restaurantId: string): Promise<IGetCategoryPositionListV2> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/restaurants/${restaurantId}/categories` });
};
// Menu v2

// Menu v1
const serviceGetCategoryPositionChains = (restaurantId: string): Promise<IGetCategoryPositionChains> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Categories/positions?restaurantId=${restaurantId}` });
};
// Menu v1
// Menu v2
const serviceGetCategoryPositionChainsV2 = (restaurantId: string): Promise<IGetCategoryPositionChains> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/restaurants/${restaurantId}/same-category-set` });
};
// Menu v2

// Menu v1
const serviceUpdateCategoryPositions = (data: IUpdateCategoryPositions): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Categories/changePositions`, data });
};
// Menu v1
// Menu v2
const serviceUpdateCategoryPositionsV2 = (data: IUpdateCategoryPositions): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/categories:change-positions`, data });
};
// Menu v2

const serviceGetCategoryRestaurantProperties = (
	args: IGetCategoryRestaurantPropertiesArguments,
): Promise<IGetCategoryRestaurantProperties> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/restaurant-categories/${args.categoryId}`,
	});
};

const serviceUpdateCategoryRestaurantProperties = (
	data: IUpdateCategoryRestaurantProperties,
): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'putWithToken',
		url: `/api/v2/restaurants/${data.restaurantId}/restaurant-categories/${data.categoryId}`,
		data,
	});
};

const serviceUpdateCategoryRestaurantPropertiesAsPatch = (
	data: IUpdateRestaurantPropertiesAsPatchForCategory,
): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/restaurant-categories/${data.categoryId}`, data });
};

const serviceUpdateRestaurantsInCategory = (data: {
	categoryId: string;
	restaurantIds: string[];
}): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/categories:update-restaurants`, data });
};

const serviceGetCategoryPhotos = (args: {
	categoryIds: string[];
	size: 1 | 2 | 3;
}): Promise<
	AxiosResponse<{
		files: {
			id: string;
			preSignedUrl: Nullable<string>;
		}[];
	}>
> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/category-photos:search`, data: args });
};

export {
	serviceGetCategoryInfo,
	serviceGetCategoryInfoV2,
	serviceGetCategoriesShort,
	serviceGetCategoriesShortV2,
	serviceGetCategoriesByCustomerShort,
	serviceCreateCategory,
	serviceCreateCategoryV2,
	serviceUpdateCategory,
	serviceUpdateCategoryV2,
	serviceGetPaginatedCategories,
	serviceGetPaginatedCategoriesV2,
	serviceDeleteCategory,
	serviceDeleteCategoryV2,
	serviceGetCategoryPositionList,
	serviceGetCategoryPositionListV2,
	serviceGetCategoryPositionChains,
	serviceGetCategoryPositionChainsV2,
	serviceUpdateCategoryPositions,
	serviceUpdateCategoryPositionsV2,
	serviceGetCategoryRestaurantProperties,
	serviceUpdateCategoryRestaurantProperties,
	serviceUpdateCategoryRestaurantPropertiesAsPatch,
	serviceUpdateRestaurantsInCategory,
	serviceGetCategoryPhotos,
};
